import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST, PUT, DELETE } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import { IDS } from "../../utils/IDS";

export const createOrderAddress = createAsyncThunk(
  "create-order-addrress",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Order.ORDER_ADDRESS, data);
      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const EditOrderAddress = createAsyncThunk(
  "create-order-addrress",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await PUT(`${APIS.Order.ORDER_ADDRESS}/${id}`, data);

      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllOrderAddress = createAsyncThunk(
  "get-order-addrress",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Order.ORDER_ADDRESS);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllSippingOrderAddress = createAsyncThunk(
  "get-sipping-order-addrress",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Order.ORDER_ADDRESS + `/${"shipping"}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getSingleOrderAddress = createAsyncThunk(
  "get-order-address-single",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Order.ORDER_ADDRESS + `/${id}`);

      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteAddress = createAsyncThunk(
  "delete-address",
  async (id, { rejectWithValue }) => {
    try {
      const response = await DELETE(APIS.Order.ORDER_ADDRESS + `/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Thunk for getting all CARTS
export const createOrder = createAsyncThunk(
  "create-order",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Order.ORDER, data);
      console.log(response, "response response");

      if (response?.success) {
        return response;
      } else {
        console.log(response, "rejectWithValue response");
        return rejectWithValue(response);
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Thunk for getting all CARTS
export const getAllOrder = createAsyncThunk(
  "get-all-orders",
  async ({ order_status_id = "" }, { rejectWithValue }) => {
    try {
      const response = await GET(
        APIS.Order.ORDER + `?order_status_id=${order_status_id || ""}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllOrderDeliver = createAsyncThunk(
  "get-all-orders-deliver",
  async ({ order_status_id = "" }, { rejectWithValue }) => {
    try {
      const response = await GET(
        APIS.Order.ORDER + `?order_status_id=${order_status_id || ""}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllReturnedOrder = createAsyncThunk(
  "get-all-Returned-orders",
  async ({ order_status_id = "" }, { rejectWithValue }) => {
    try {
      const response = await GET(
        APIS.Order.ALL_RETURN + `?order_status_id=${order_status_id || ""}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllCancelledOrder = createAsyncThunk(
  "get-all-Cancelled-orders",
  async ({ order_status_id = "" }, { rejectWithValue }) => {
    try {
      const response = await GET(
        APIS.Order.ALL_CANCEL + `?order_status_id=${order_status_id || ""}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting CART
export const getOrder = createAsyncThunk(
  "get-order",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Order.ORDER + `/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCanceledOrder = createAsyncThunk(
  "get-cancel-order",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Order.SINGLE_CANCEL + `/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getReturnedOrder = createAsyncThunk(
  "get-return-order",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Order.SINGLE_RETURN + `/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting CART
export const cancelOrder = createAsyncThunk(
  "cancel-order",
  async ({ order_id, data }, { rejectWithValue }) => {
    try {
      console.log("datd hererer", order_id, data);

      const response = await POST(APIS.Order.ORDER_CANCEL + `/${order_id}`, data);
      return response;
    } catch (error) {
      console.error("Cancel order failed:", error);
      return rejectWithValue(
        error.response?.data || error.message || "Something went wrong"
      );
    }
  }
);

// Thunk for getting CART
export const returnOrder = createAsyncThunk(
  "return-order",
  async ({ order_id, data }, { rejectWithValue }) => {
    console.log(order_id, data, " order_id, DataToSend ");

    try {
      const response = await POST(APIS.Order.ORDER_RETURN + `/${order_id}`, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createOrderMessage = createAsyncThunk(
  "create-order-message",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Order.ORDER + `/message`, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getOrderMessage = createAsyncThunk(
  "get-order-message",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Order.ORDER + `/message/data`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const CouponApplyed = createAsyncThunk(
  "coupon-applyed",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Order.COUPON_APPLYED, data);
      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const postReorder = createAsyncThunk(
  "postReorder",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Order.REORDER + `/${id}`);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// export const getCoupons = createAsyncThunk(
//   "get-coupon",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await GET(APIS.Order.COUPON);
//       return response;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const OrderCalculation = createAsyncThunk(
  "order-calculation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Order.ORDER_CALCULATION, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const OrderResponse = createAsyncThunk(
  "order-response",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(`${APIS.Order.ORDER}/phonepay-check-status`, data);

      if (response?.success) {
        return response;
      } else {
        return rejectWithValue(response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const handleAsyncState = (state, action, isSignin = false) => {
  switch (action.type) {
    case "pending":
      state.status = "loading";
      break;
    case "fulfilled":
      state.status = "succeeded";
      if (isSignin) {
        state.token = action.payload;
        state.is_signin = true;
      }
      break;
    case "rejected":
      state.status = "failed";
      state.error = action.payload;
      if (isSignin) state.is_signin = false;
      break;
    default:
      return state;
  }
};

// Create the slice
const orderSlice = createSlice({
  name: "order",
  initialState: {
    allOrders: [],
    allOrdersDeliver: [],
    allOrdersAddress: [],
    allReturnedOrders: [],
    allCancelledOrders: [],
    allSppingOrdersAddress: [],
    orderAddress: {},
    order: {},
    orderMessage: [],
    all_coupons: [],
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.status = "loading";

      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "createOrder Response payload in fulfilled case:",
          action.payload
        );

      })
      .addCase(createOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(getAllOrder.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getAllOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allOrders = action.payload?.data || [];


      })
      .addCase(getAllOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(getAllOrderDeliver.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getAllOrderDeliver.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allOrdersDeliver = action.payload?.data || [];


      })
      .addCase(getAllOrderDeliver.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(getAllReturnedOrder.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getAllReturnedOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allReturnedOrders = action.payload?.data || [];
        console.log(
          "getAllReturnedOrder Response payload in fulfilled case:",
          action.payload
        );

      })
      .addCase(getAllReturnedOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(getAllCancelledOrder.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getAllCancelledOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allCancelledOrders = action.payload?.data || [];
        console.log(
          "getAllReturnedOrder Response payload in fulfilled case:",
          action.payload
        );

      })
      .addCase(getAllCancelledOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(getOrder.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "getOrder Response payload in fulfilled case:",
          action.payload
        );
        state.order = action.payload?.data || {};

      })
      .addCase(getOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(getReturnedOrder.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getReturnedOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "getReturnedOrder Response payload in fulfilled case:",
          action.payload
        );
        state.order = action.payload?.data || {};

      })
      .addCase(getReturnedOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(getCanceledOrder.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getCanceledOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "getCanceledOrder Response payload in fulfilled case:",
          action.payload
        );
        state.order = action.payload?.data || {};

      })
      .addCase(getCanceledOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(cancelOrder.pending, (state) => {
        state.status = "loading";

      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "cancelOrder Response payload in fulfilled case:",
          action.payload.data
        );
      })
      .addCase(cancelOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(returnOrder.pending, (state) => {
        state.status = "loading";

      })
      .addCase(returnOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "returnOrder Response payload in fulfilled case:",
          action.payload.data
        );

      })
      .addCase(returnOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(createOrderAddress.pending, (state) => {
        state.status = "loading";

      })
      .addCase(createOrderAddress.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "createOrder Response payload in fulfilled case:",
          action.payload
        );

      })
      .addCase(createOrderAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(getAllOrderAddress.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getAllOrderAddress.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allOrdersAddress = action.payload || [];


      })
      .addCase(getAllOrderAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(getAllSippingOrderAddress.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getAllSippingOrderAddress.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allSppingOrdersAddress = action.payload || [];


      })
      .addCase(getAllSippingOrderAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(getSingleOrderAddress.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getSingleOrderAddress.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.orderAddress = action.payload?.data || {};
        console.log(
          "getOrder single Response payload in fulfilled case:",
          action.payload
        );
        console.log("single prder after fulfilled", state.orderAddress);
      })
      .addCase(getSingleOrderAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(deleteAddress.pending, (state) => {
        state.status = "loading";

      })
      .addCase(deleteAddress.fulfilled, (state, action) => {
        state.status = "succeeded";

      })
      .addCase(deleteAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })
      .addCase(createOrderMessage.pending, (state) => {
        state.status = "loading";

      })
      .addCase(createOrderMessage.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "createOrder Response payload in fulfilled case:",
          action.payload
        );

      })
      .addCase(createOrderMessage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })
      .addCase(getOrderMessage.pending, (state) => {
        state.status = "loading";

      })
      .addCase(getOrderMessage.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "getOrder Response payload in fulfilled case:",
          action.payload
        );
        state.orderMessage = action.payload?.data || [];

      })
      .addCase(getOrderMessage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;

      })

      .addCase(CouponApplyed.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true)
      )
      .addCase(CouponApplyed.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true
        )
      )
      .addCase(CouponApplyed.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true
        )
      )

      .addCase(OrderCalculation.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true)
      )
      .addCase(OrderCalculation.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true
        )
      )
      .addCase(OrderCalculation.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true
        )
      )

      .addCase(OrderResponse.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true)
      )
      .addCase(OrderResponse.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true
        )
      )
      .addCase(OrderResponse.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true
        )
      )

      .addCase(postReorder.pending, (state) => {
        state.status = "loading";
      })
      .addCase(postReorder.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(postReorder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });

    //   .addCase(getCoupons.pending, (state) => {
    //   state.status = "loading";
    //     
    // })
    // .addCase(getCoupons.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.all_coupons = action.payload?.data || [];
    //   console.log(
    //     "getAllOrder Response payload in fulfilled case:",
    //     action.payload
    //   );
    //     
    // })
    // .addCase(getCoupons.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    //      
    // })
  },
});

export default orderSlice.reducer;
